import { object, string, array, number } from '@gogame/schemas';

import {
  AGREEMENT,
  AGREEMENT_TYPE,
  BUDGET,
  PERIOD,
  BUSINESS_PARTNER,
  BUSINESS_PARTNER_VERSION,
  AMOUNT,
  CURRENCY_CODE,
  PAYMENT_TERMS,
  PAYMENT_TERMS_ID,
  EXPENSE_TYPE,
  TRAFFIC_RESTRICTIONS,
  INVOICE_REQUIREMENTS,
  PAYMENT_DETAILS,
  BANK_NAME,
  BANK_ADDRESS,
  ACCOUNT_NUMBER,
  ACCOUNT_NAME,
  SWIFT_CODE,
  IBAN,
  LEGAL_CONTACT,
  FIRST_NAME,
  LAST_NAME,
  EMAIL,
} from './constants';

export const ioValidationsSchema = object({
  [BUSINESS_PARTNER]: number().required('Business partner is required'),
  [BUSINESS_PARTNER_VERSION]: number().required('BP version is required'),
});

export const ioApprovalValidationSchema = ioValidationsSchema.shape({
  [PAYMENT_TERMS]: object({
    [PAYMENT_TERMS_ID]: number().required('Payment terms is required'),
    [EXPENSE_TYPE]: number().required('Expense type is required'),
  }).when(`${AGREEMENT}.${AGREEMENT_TYPE}`, (agreementType, schema) => {
    return agreementType === 0
      ? schema.shape({
          [TRAFFIC_RESTRICTIONS]: array(number()).required(
            'Traffic restrictions is required'
          ),
          [INVOICE_REQUIREMENTS]: array(number()).required(
            'Invoice requirements is required'
          ),
        })
      : schema;
  }),
  [BUDGET]: object({
    [AMOUNT]: string().required('Total budget amount is required'),
  }),
  [PAYMENT_DETAILS]: object({
    [BANK_NAME]: string().required('Bank name is required'),
    [BANK_ADDRESS]: string().required('Bank address is required'),
    [ACCOUNT_NUMBER]: string().required('Account number is required'),
    [ACCOUNT_NAME]: string().required('Account name is required'),
    [SWIFT_CODE]: string().required('Swift code is required'),
    [IBAN]: string().required('IBAN is required'),
  }),
  [LEGAL_CONTACT]: object({
    [FIRST_NAME]: string().required('First Name is required'),
    [LAST_NAME]: string().required('Last Name is required'),
    [EMAIL]: string().email().required('Email is required'),
  }),
});

export const paymentTermsValidationSchema = object({
  [BUSINESS_PARTNER_VERSION]: number().required(),
  [BUSINESS_PARTNER]: number().required(),
});

export const budgetTotalAmountSchema = object({
  [AMOUNT]: string(),
  [CURRENCY_CODE]: string(),
});

export const budgetValidationSchema = object({
  [PERIOD]: array(string()).required(),
  [BUDGET]: object({
    [CURRENCY_CODE]: string().required(),
  }),
});

export const budgetParamsSchema = object({
  [PERIOD]: array(string()).required(),
  [BUDGET]: budgetTotalAmountSchema,
});

export const currencyValidationSchema = object({
  [BUSINESS_PARTNER_VERSION]: number().required(),
  [BUSINESS_PARTNER]: number().required(),
});

export const monthlyBudgetValidationSchema = object({
  [PERIOD]: array(string()).required(),
  [BUDGET]: object({
    [CURRENCY_CODE]: string().required(),
  }),
});

export const monthlyBudgetParamsSchema = object({
  [PERIOD]: array(string()).required(),
  [BUDGET]: budgetTotalAmountSchema,
});

export const bpDetailsValidationSchema = object({
  [BUSINESS_PARTNER]: number().required(),
  [BUSINESS_PARTNER_VERSION]: number().required(),
});

export const bpVersionValidationSchema = object({
  [BUSINESS_PARTNER]: number().required(),
});
